import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseDeleteMutation, IDeleteFn, ITrainingEvent, IGetDeleteRequest } from '../../interfaces'

const getDeleteTrainingEventMutationRequest: IGetDeleteRequest = params => {
  return {
    method: 'delete',
    url: `${config.baseUrl}/TrainingEvents/`,
  }
}

const useDeleteTrainingEventMutation: IUseDeleteMutation<ITrainingEvent, number> = (params, options = {}) => {
  const request = useMemo(() => getDeleteTrainingEventMutationRequest(params), [params])

  const deleteTraining: IDeleteFn<ITrainingEvent> = useCallback(
    async id => axios({ ...request, url: request.url + id }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingEvent, Error, any>({ mutationFn: deleteTraining, ...options })

  return response
}

export default useDeleteTrainingEventMutation
